export default [
    { cc: 'aed', symbol: '\u062f.\u0625', name: 'uae dirham' },
    { cc: 'afn', symbol: 'Afs', name: 'Afghan afghani' },
    { cc: 'all', symbol: 'L', name: 'Albanian lek' },
    { cc: 'amd', symbol: 'AMD', name: 'Armenian dram' },
    { cc: 'ang', symbol: 'NA\u0192', name: 'Netherlands Antillean gulden' },
    { cc: 'aoa', symbol: 'Kz', name: 'Angolan kwanza' },
    { cc: 'ars', symbol: '$', name: 'Argentine peso' },
    { cc: 'aud', symbol: '$', name: 'Australian dollar' },
    { cc: 'awg', symbol: '\u0192', name: 'Aruban florin' },
    { cc: 'azn', symbol: 'AZN', name: 'Azerbaijani manat' },
    {
        cc: 'bam',
        symbol: 'KM',
        name: 'Bosnia and Herzegovina konvertibilna marka',
    },
    { cc: 'bbd', symbol: 'Bds$', name: 'Barbadian dollar' },
    { cc: 'bdt', symbol: '\u09f3', name: 'Bangladeshi taka' },
    { cc: 'bgn', symbol: 'BGN', name: 'Bulgarian lev' },
    { cc: 'bhd', symbol: '.\u062f.\u0628', name: 'Bahraini dinar' },
    { cc: 'bif', symbol: 'FBu', name: 'Burundi franc' },
    { cc: 'bmd', symbol: 'BD$', name: 'Bermudian dollar' },
    { cc: 'bnd', symbol: 'B$', name: 'Brunei dollar' },
    { cc: 'bob', symbol: 'Bs.', name: 'Bolivian boliviano' },
    { cc: 'brl', symbol: 'R$', name: 'Brazilian real' },
    { cc: 'bsd', symbol: 'B$', name: 'Bahamian dollar' },
    { cc: 'btn', symbol: 'Nu.', name: 'Bhutanese ngultrum' },
    { cc: 'bwp', symbol: 'P', name: 'Botswana pula' },
    { cc: 'byr', symbol: 'Br', name: 'Belarusian ruble' },
    { cc: 'bzd', symbol: 'BZ$', name: 'Belize dollar' },
    { cc: 'cad', symbol: '$', name: 'Canadian dollar' },
    { cc: 'cdf', symbol: 'F', name: 'Congolese franc' },
    { cc: 'chf', symbol: 'Fr.', name: 'Swiss franc' },
    { cc: 'clp', symbol: '$', name: 'Chilean peso' },
    { cc: 'cny', symbol: '\u00a5', name: 'Chinese/Yuan renminbi' },
    { cc: 'cop', symbol: 'Col$', name: 'Colombian peso' },
    { cc: 'crc', symbol: '\u20a1', name: 'Costa Rican colon' },
    { cc: 'cuc', symbol: '$', name: 'Cuban peso' },
    { cc: 'cve', symbol: 'Esc', name: 'Cape Verdean escudo' },
    { cc: 'czk', symbol: 'K\u010d', name: 'Czech koruna' },
    { cc: 'djf', symbol: 'Fdj', name: 'Djiboutian franc' },
    { cc: 'dkk', symbol: 'Kr', name: 'Danish krone' },
    { cc: 'dop', symbol: 'RD$', name: 'Dominican peso' },
    { cc: 'dzd', symbol: '\u062f.\u062c', name: 'Algerian dinar' },
    { cc: 'eek', symbol: 'KR', name: 'Estonian kroon' },
    { cc: 'egp', symbol: '\u00a3', name: 'Egyptian pound' },
    { cc: 'ern', symbol: 'Nfa', name: 'Eritrean nakfa' },
    { cc: 'etb', symbol: 'Br', name: 'Ethiopian birr' },
    { cc: 'eur', symbol: '\u20ac', name: 'European Euro' },
    { cc: 'fjd', symbol: 'FJ$', name: 'Fijian dollar' },
    { cc: 'fkp', symbol: '\u00a3', name: 'Falkland Islands pound' },
    { cc: 'gbp', symbol: '\u00a3', name: 'British pound' },
    { cc: 'gel', symbol: 'GEL', name: 'Georgian lari' },
    { cc: 'ghs', symbol: 'GH\u20b5', name: 'Ghanaian cedi' },
    { cc: 'gip', symbol: '\u00a3', name: 'Gibraltar pound' },
    { cc: 'gmd', symbol: 'D', name: 'Gambian dalasi' },
    { cc: 'gnf', symbol: 'FG', name: 'Guinean franc' },
    { cc: 'gqe', symbol: 'CFA', name: 'Central African CFA franc' },
    { cc: 'gtq', symbol: 'Q', name: 'Guatemalan quetzal' },
    { cc: 'gyd', symbol: 'GY$', name: 'Guyanese dollar' },
    { cc: 'hkd', symbol: 'HK$', name: 'Hong Kong dollar' },
    { cc: 'hnl', symbol: 'L', name: 'Honduran lempira' },
    { cc: 'hrk', symbol: 'kn', name: 'Croatian kuna' },
    { cc: 'htg', symbol: 'G', name: 'Haitian gourde' },
    { cc: 'huf', symbol: 'Ft', name: 'Hungarian forint' },
    { cc: 'idr', symbol: 'Rp', name: 'Indonesian rupiah' },
    { cc: 'ils', symbol: '\u20aa', name: 'Israeli new sheqel' },
    { cc: 'inr', symbol: '\u20B9', name: 'Indian rupee' },
    { cc: 'iqd', symbol: '\u062f.\u0639', name: 'Iraqi dinar' },
    { cc: 'irr', symbol: 'IRR', name: 'Iranian rial' },
    { cc: 'isk', symbol: 'kr', name: 'Icelandic kr\u00f3na' },
    { cc: 'jmd', symbol: 'J$', name: 'Jamaican dollar' },
    { cc: 'jod', symbol: 'JOD', name: 'Jordanian dinar' },
    { cc: 'jpy', symbol: '\u00a5', name: 'Japanese yen' },
    { cc: 'kes', symbol: 'KSh', name: 'Kenyan shilling' },
    { cc: 'kgs', symbol: '\u0441\u043e\u043c', name: 'Kyrgyzstani som' },
    { cc: 'khr', symbol: '\u17db', name: 'Cambodian riel' },
    { cc: 'kmf', symbol: 'KMF', name: 'Comorian franc' },
    { cc: 'kpw', symbol: 'W', name: 'North Korean won' },
    { cc: 'krw', symbol: 'W', name: 'South Korean won' },
    { cc: 'kwd', symbol: 'KWD', name: 'Kuwaiti dinar' },
    { cc: 'kyd', symbol: 'KY$', name: 'Cayman Islands dollar' },
    { cc: 'kzt', symbol: 'T', name: 'Kazakhstani tenge' },
    { cc: 'lak', symbol: 'KN', name: 'Lao kip' },
    { cc: 'lbp', symbol: '\u00a3', name: 'Lebanese lira' },
    { cc: 'lkr', symbol: 'Rs', name: 'Sri Lankan rupee' },
    { cc: 'lrd', symbol: 'L$', name: 'Liberian dollar' },
    { cc: 'lsl', symbol: 'M', name: 'Lesotho loti' },
    { cc: 'ltl', symbol: 'Lt', name: 'Lithuanian litas' },
    { cc: 'lvl', symbol: 'Ls', name: 'Latvian lats' },
    { cc: 'lyd', symbol: 'LD', name: 'Libyan dinar' },
    { cc: 'mad', symbol: 'MAD', name: 'Moroccan dirham' },
    { cc: 'mdl', symbol: 'MDL', name: 'Moldovan leu' },
    { cc: 'mga', symbol: 'FMG', name: 'Malagasy ariary' },
    { cc: 'mkd', symbol: 'MKD', name: 'Macedonian denar' },
    { cc: 'mmk', symbol: 'K', name: 'Myanma kyat' },
    { cc: 'mnt', symbol: '\u20ae', name: 'Mongolian tugrik' },
    { cc: 'mop', symbol: 'P', name: 'Macanese pataca' },
    { cc: 'mro', symbol: 'UM', name: 'Mauritanian ouguiya' },
    { cc: 'mur', symbol: 'Rs', name: 'Mauritian rupee' },
    { cc: 'mvr', symbol: 'Rf', name: 'Maldivian rufiyaa' },
    { cc: 'mwk', symbol: 'MK', name: 'Malawian kwacha' },
    { cc: 'mxn', symbol: '$', name: 'Mexican peso' },
    { cc: 'myr', symbol: 'RM', name: 'Malaysian ringgit' },
    { cc: 'mzm', symbol: 'MTn', name: 'Mozambican metical' },
    { cc: 'nad', symbol: 'N$', name: 'Namibian dollar' },
    { cc: 'ngn', symbol: '\u20a6', name: 'Nigerian naira' },
    { cc: 'nio', symbol: 'C$', name: 'Nicaraguan c\u00f3rdoba' },
    { cc: 'nok', symbol: 'kr', name: 'Norwegian krone' },
    { cc: 'npr', symbol: 'NRs', name: 'Nepalese rupee' },
    { cc: 'nzd', symbol: 'NZ$', name: 'New Zealand dollar' },
    { cc: 'omr', symbol: 'OMR', name: 'Omani rial' },
    { cc: 'pab', symbol: 'B./', name: 'Panamanian balboa' },
    { cc: 'pen', symbol: 'S/.', name: 'Peruvian nuevo sol' },
    { cc: 'pgk', symbol: 'K', name: 'Papua New Guinean kina' },
    { cc: 'php', symbol: '\u20b1', name: 'Philippine peso' },
    { cc: 'pkr', symbol: 'Rs.', name: 'Pakistani rupee' },
    { cc: 'pln', symbol: 'z\u0142', name: 'Polish zloty' },
    { cc: 'pyg', symbol: '\u20b2', name: 'Paraguayan guarani' },
    { cc: 'qar', symbol: 'QR', name: 'Qatari riyal' },
    { cc: 'ron', symbol: 'L', name: 'Romanian leu' },
    { cc: 'rsd', symbol: 'din.', name: 'Serbian dinar' },
    { cc: 'rub', symbol: 'R', name: 'Russian ruble' },
    { cc: 'sar', symbol: 'SR', name: 'Saudi riyal' },
    { cc: 'sbd', symbol: 'SI$', name: 'Solomon Islands dollar' },
    { cc: 'scr', symbol: 'SR', name: 'Seychellois rupee' },
    { cc: 'sdg', symbol: 'SDG', name: 'Sudanese pound' },
    { cc: 'sek', symbol: 'kr', name: 'Swedish krona' },
    { cc: 'sgd', symbol: 'S$', name: 'Singapore dollar' },
    { cc: 'shp', symbol: '\u00a3', name: 'Saint Helena pound' },
    { cc: 'sll', symbol: 'Le', name: 'Sierra Leonean leone' },
    { cc: 'sos', symbol: 'Sh.', name: 'Somali shilling' },
    { cc: 'srd', symbol: '$', name: 'Surinamese dollar' },
    { cc: 'syp', symbol: 'LS', name: 'Syrian pound' },
    { cc: 'szl', symbol: 'E', name: 'Swazi lilangeni' },
    { cc: 'thb', symbol: '\u0e3f', name: 'Thai baht' },
    { cc: 'tjs', symbol: 'TJS', name: 'Tajikistani somoni' },
    { cc: 'tmt', symbol: 'm', name: 'Turkmen manat' },
    { cc: 'tnd', symbol: 'DT', name: 'Tunisian dinar' },
    { cc: 'try', symbol: 'TRY', name: 'Turkish new lira' },
    { cc: 'ttd', symbol: 'TT$', name: 'Trinidad and Tobago dollar' },
    { cc: 'twd', symbol: 'NT$', name: 'New Taiwan dollar' },
    { cc: 'tzs', symbol: 'TZS', name: 'Tanzanian shilling' },
    { cc: 'uah', symbol: 'UAH', name: 'Ukrainian hryvnia' },
    { cc: 'ugx', symbol: 'USh', name: 'Ugandan shilling' },
    { cc: 'usd', symbol: 'US$', name: 'United States dollar' },
    { cc: 'uyu', symbol: '$U', name: 'Uruguayan peso' },
    { cc: 'uzs', symbol: 'UZS', name: 'Uzbekistani som' },
    { cc: 'veb', symbol: 'Bs', name: 'Venezuelan bolivar' },
    { cc: 'vnd', symbol: '\u20ab', name: 'Vietnamese dong' },
    { cc: 'vuv', symbol: 'VT', name: 'Vanuatu vatu' },
    { cc: 'wst', symbol: 'WS$', name: 'Samoan tala' },
    { cc: 'xaf', symbol: 'CFA', name: 'Central African CFA franc' },
    { cc: 'xcd', symbol: 'EC$', name: 'East Caribbean dollar' },
    { cc: 'xdr', symbol: 'SDR', name: 'Special Drawing Rights' },
    { cc: 'xof', symbol: 'CFA', name: 'West African CFA franc' },
    { cc: 'xpf', symbol: 'xpf', name: 'CFP franc' }, // default { cc: "xpf", symbol: "F", "name": "CFP franc" },
    { cc: 'yer', symbol: 'YER', name: 'Yemeni rial' },
    { cc: 'zar', symbol: 'R', name: 'South African rand' },
    { cc: 'zmk', symbol: 'ZK', name: 'Zambian kwacha' },
    { cc: 'zwr', symbol: 'Z$', name: 'Zimbabwean dollar' },
]
